import { render, staticRenderFns } from "./WolihubDashboard.vue?vue&type=template&id=759a2eb1&scoped=true"
import script from "./WolihubDashboard.vue?vue&type=script&lang=js"
export * from "./WolihubDashboard.vue?vue&type=script&lang=js"
import style0 from "./WolihubDashboard.vue?vue&type=style&index=0&id=759a2eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759a2eb1",
  null
  
)

export default component.exports